export const server = {
  data() {
    let url // tes1
    if (this.$i18n.locale === 'en') {
      var message = 'Hello, welcome come to Magic Compass, How may I help you today?'
      url =
        'https://mza.kicdek.com/Web/im.aspx?_=t&accountid=137137&gid=3&e=%E5%AE%9D%E6%B1%87%E6%8A%95%E8%B5%84&lng=en&ctitle=Magic Compass LiveChat&cprologue=' +
        message
    } else if (this.$i18n.locale === 'zh') {
      message =
        '3月首充活动重磅登场！只要您是2023年02月28日至2023年03月31日之间激活(首入金)的用户，将享有领取赠金资格。首入金72小时内，净入金越高，赠金越多，最高可获得1688元充值红包；入金后30天内完成对应手数交易，还可以额外获得iPhone14奖励！我可以马上为您查询活动资格，请问您的手机号码是多少呢'
      url = 'https://mza.kicdek.com/Web/im.aspx?_=t&accountid=137137&gid=1&e=%E5%AE%9D%E6%B1%87%E6%8A%95%E8%B5%84&lng=cn&ctitle=在线客服&cprologue=' + message
    } else if (this.$i18n.locale === 'tw') {
      message =
        '3月首充活動重磅登場！只要您是2023年02月28日至2023年03月31日之間激活(首入金)的用戶，將享有領取贈金資格。首入金72小時內，淨入金越高，贈金越多，最高可獲得1688元充值紅包；入金後30天內完成對應手數交易，還可以額外獲得iPhone14獎勵！我可以馬上為您查詢活動資格，請問您的手機號碼是多少呢？'
      url = 'https://mza.kicdek.com/Web/im.aspx?_=t&accountid=137137&gid=2&e=%E5%AE%9D%E6%B1%87%E6%8A%95%E8%B5%84&lng=big5&ctitle=在線客服&cprologue=' + message
    }
    return {
      serverUrl: url,
    }
  },
  methods: {
    handleServer() {
      console.log(localStorage.getItem('varietyType'), 111)
      console.log(this.getCookie('accountMemory'), 222)
      var h = Math.round(($(window).height() - 500) / 2)
      var w = Math.round(($(window).width() - 500) / 2)
      if (localStorage.getItem('varietyType') == 1) {
        window.open(
        'https://h5.ai-mchat.com/?account='+this.getCookie('accountMemory')+'&source=1&appId=10019&mchId=241207&entranceId=22',
        'newwindow',
        'top=' + h + ',left=' + w + ',height=600,width=740,toolbar=no,menubar=no,scrollbars=no,resizable=yes,location=no,status=no'
      )
      } else {
        window.open(
          'https://h5.ai-mchat.com/?account='+this.getCookie('accountMemory')+'&source=1&appId=10020&mchId=241207&entranceId=22',
          'newwindow',
          'top=' + h + ',left=' + w + ',height=600,width=740,toolbar=no,menubar=no,scrollbars=no,resizable=yes,location=no,status=no'
        )
      }
      
      
      // typeof analysesData == 'function' && analysesData('2', '2', '')
      // window.open(
      //   'https://f88.live800.com/live800/chatClient/chatbox1591636.jspc?companyID=1591636&configID=158703&jid=1759991554&s=1',
      //   'newwindow',
      //   'top=' + h + ',left=' + w + ',height=600,width=740,toolbar=no,menubar=no,scrollbars=no,resizable=yes,location=no,status=no'
      // )
      // return false
    },
    getCookie(name) {
      var arr,
        reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')

      if ((arr = document.cookie.match(reg))) {
        this.clientid = arr[2]
        return arr[2]
      } else {
        return false
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/server.js